import React, { useMemo, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import Hint from 'components/Hint/Hint'

import './Header.scss'

const HINT_NAME = 'editor-modal-header-nav'

const Header = ({
    title,
    navItems = [],
    classes = [],
    activeNavItemId,
    onClose = () => {
        /**/
    },
    onChangeNavItem = () => {
        /**/
    },
    isCloseIcon = true,
}) => {
    const navItemRef = useRef()
    const { t } = useTranslation()
    const renderNav = useMemo(() => {
        return (
            <div className="modal-header__nav-wrapper">
                <ul className="modal-header__nav">
                    {Object.values(navItems).map((item, i) => {
                        const isActive = activeNavItemId === item.id
                        const isElemTwo = i === 1
                        return (
                            <li
                                className={`modal-header__nav-item${
                                    isActive ? ' modal-header__nav-item--is-active' : ''
                                }`}
                                key={item.id}
                                onClick={() => onChangeNavItem(item.id)}
                                ref={isElemTwo ? navItemRef : null}
                            >
                                <p>{item.label}</p>
                            </li>
                        )
                    })}
                </ul>
            </div>
        )
    }, [navItems, activeNavItemId, onChangeNavItem])

    return (
        <div className={`modal-header ${classes.join(' ')}`}>
            {title && (
                <div className="modal-header__title" title={title}>
                    {title}
                </div>
            )}
            {navItems.length ? renderNav : null}
            <Hint
                isShow={navItems.length > 1}
                placement="bottom"
                hintName={HINT_NAME}
                parentRef={navItemRef}
                text={t('To continue editing, go to the next step')}
            />
            {isCloseIcon ? <div className="modal-header__close" onClick={() => onClose()} /> : null}
        </div>
    )
}

export default Header
